import { BASIC_INITIAL_STATE } from '../../../utils/HttpHelper';

import getMeetTimesStatus from './GetMeetTimesStatus';

const MeetTimesStatusData = { INITIAL_STATE: { ...BASIC_INITIAL_STATE }, getMeetTimesStatus };
export default MeetTimesStatusData;